import React, { useState, useEffect, useRef, startTransition, useContext } from 'react';
import { 
  FiUser, FiMapPin, 
  FiPhone, FiChevronDown, FiChevronUp, FiPrinter
} from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Slide } from 'react-toastify';
import Select from 'react-select';
import { BASE_URL, GET_PATIENTS, BIIL_ENTRY_LOAD, POST_BILL_ENTRY, GET_GENERAL_BILLS, GET_OP_DETAILS   } from '../utlilities/config';
import { getWebUserInfo, initializeWebUserInfo } from '../utlilities/webConfig';
import { FiPlus} from "react-icons/fi";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import NormalBillPrint from '../components/NormalBillPrint';
import KotBillPrint from '../components/KotBillPrint';
import { toPng } from 'html-to-image';
import { TabContext } from '../components/TabbedLayout';

// Enhanced Spinner Component
const Spinner = () => (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-white bg-opacity-80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
        <p className="text-indigo-600 font-medium">Loading...</p>
      </div>
    </div>
);


const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '34px',
    height: '34px',
    backgroundColor: '#f9fafb',
    borderColor: state.isFocused ? '#6366f1' : '#b5b6b8ff',
    boxShadow: state.isFocused ? '0 0 0 1px #6366f1' : 'none',
    borderRadius: '0.5rem',
    '&:hover': {
      borderColor: '#6366f1',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    height: '34px',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px',
    padding: '0px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '34px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#92c3fcff'
      : state.isFocused
      ? '#92c3fcff'
      : '#ffffff',
    color: state.isSelected ? '#000000ff' : state.isFocused ? '#ffffff' : '#000000',
    fontWeight: '500',
    padding: '6px 8px',
    '&:hover': {
      backgroundColor: '#92c3fcff',
      color: '#000000ff',
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 999,
    borderRadius: '0.5rem',
    overflow: 'hidden',
    boxShadow:
      '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};


const OpBilling = () => {
  const tabContext = useContext(TabContext);
  const activeTabId = tabContext?.activeTabId;
  const token = localStorage.getItem('accessToken');
  const [loading, setLoading] = useState(false);
  const [billedDate, setBilledDate] = useState('')
  const [originalBillDate, setOriginalBillDate] = useState(null); // Store original bill date from Created_at
  const [pageno, setPageno] = useState(1);
  const [pagesize, setPagesize] = useState(100);
  const [patients, setPatients] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [newinvoiceNumber, setNewInvoiceNumber] = useState('')
  const [mobileInput, setMobileInput] = useState('');
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [currentDateTime, setCurrentDateTime] = useState('');
  const [items, setItems] = useState([]);
  const [products, setProducts] = useState([{ item: null, amount: "", type: "", qty: 1, id: null, name: "", item_discount: 0, rate: 0 }]);
  const [paymentMode, setPaymentMode] = useState('Cash');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [printAfterSave, setPrintAfterSave] = useState(false);
  const [sysInfo, setSysInfo] = useState({});
  const [clientInfo, setClientInfo] = useState({});
  const [userInfo, setUserInfo] = useState({})
  const [permissions, setPermissions] = useState({});

  const [generalsettings, setGeneralSettings] = useState({});
  const [payingAmount, setPayingAmount] = useState(0); 
  const [prevBalanceDue, setPrevBalanceDue] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [searchOpnum, setSearchOpnum] = useState('');
  const [sequence, setSequence] = useState('');
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const navigate = useNavigate();

  const [id, setId] = useState('')
  const [edit, setEdit] = useState('')

  // Time-based billing states for OBSER items
  const [showTimePopup, setShowTimePopup] = useState(false);
  const [timePopupData, setTimePopupData] = useState({
    index: null,
    hours: 0,
    minutes: 0,
    baseRate: 0,
    itemName: ''
  });
  const hoursInputRef = useRef(null);

  let { ids, edits , sequences} = useParams();
  console.log('heree idd',ids,  edits, sequences)

  // Focus opnum field on mount and when tab becomes active
  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      opnumRef.current?.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, [activeTabId]); // Re-run when activeTabId changes (tab switch)

  // Handle URL params on initial mount only
  useEffect(() => {
    if(ids && edits && sequences){
      getItemDatasparms(ids, sequences)
    }
  }, []); // Only run on mount

  const searchOpnumRef = useRef(null)
  const mobileInputRef = useRef(null);
  const numberRef = useRef(null);
  const nameRef = useRef(null);
  const ageRef = useRef(null);
  const GenderRef = useRef(null);
  const doctorSelectRef = useRef(null);
  const productRefs = useRef([]);
  const rateRefs = useRef([]);
  const qtyRefs = useRef([]);
  const amountRefs = useRef([]);
  const opnumRef = useRef(null);
  const loadedOpnumRef = useRef(''); // Last OP number whose details were successfully loaded
  const normalBillPrintRef = useRef(null);
  const submitbtnRef = useRef(null);
  const isSavingRef = useRef(false); // Track if save is in progress to prevent double submission

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [editNumber, setEditNumber] = useState('');
  const [editName, seteditName] = useState('');
  const [editAge, setEditAge] = useState('');
  const [editGender, setEditGender] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      let sysinfo;
      let generalSetting;
      let client_info;
      let userinfo;
      let finac_year;
      let userRolesData;


      if(isElectron()){
        userinfo = await ipcRenderer.invoke('store-get', 'userInfo');
        sysinfo = await ipcRenderer.invoke('store-get', 'sysInfo');
        client_info = await ipcRenderer.invoke('store-get', 'clientInfo');
        finac_year = await ipcRenderer.invoke('store-get', 'finac_year');
        userRolesData = await ipcRenderer.invoke('store-get', 'user_role');
        
        generalSetting = await ipcRenderer.invoke('store-get', 'generalopsettings');
      } else {
        initializeWebUserInfo();
        const webInfo = getWebUserInfo();
        userinfo = webInfo.userInfo;
        sysinfo = webInfo.sysInfo;
        generalSetting = webInfo.generalopsettings || webInfo.generalSettings;
        client_info = webInfo.clientInfo;
        userRolesData = webInfo.user_role;
      }
      setSysInfo(sysinfo);
      setGeneralSettings(generalSetting);
      console.log('generalSetting', generalSetting)
      setClientInfo(client_info);
      setUserInfo(userinfo);
      if (finac_year) {
        setSequence(finac_year);
      }
      setPermissions(processPermissions(userRolesData || []));

      if(generalSetting?.GbAutoBillPrint){
        setPrintAfterSave(true)
      } else  {
        setPrintAfterSave(false)
      }
      //setPrintAfterSave
    };

    fetchData();
  }, []);

  const processPermissions = (roles = []) => {
    const permissionsMap = {};
    (Array.isArray(roles) ? roles : []).forEach((role) => {
      (role.modules || []).forEach((module) => {
        permissionsMap[module.moduleName] = module.permissions;
      });
    });
    return permissionsMap;
  };

  const hasPermission = (moduleName, action) => {
    return permissions[moduleName]?.[action] || false;
  };

  const canEditOpBill = userInfo?.Designation === 'Admin' || hasPermission('Edit Op Bill', 'Create');

  const formatBilledDate = (date) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate().toString().padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();
  
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
  
    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    const handleWheel = (e) => {
      // Check if the target is a number input
      if (e.target.type === 'number') {
        e.target.blur();
      }
    };

    const handleKeyDown = (e) => {
      // Check if the target is a number input
      if (e.target.type === 'number') {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          e.preventDefault();
        }
      }
    };

    // Add event listeners
    document.addEventListener('wheel', handleWheel, { capture: true });
    document.addEventListener('keydown', handleKeyDown, { capture: true });

    // Cleanup
    return () => {
      document.removeEventListener('wheel', handleWheel, { capture: true });
      document.removeEventListener('keydown', handleKeyDown, { capture: true });
    };
  }, []);

  // Close payment options menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showPaymentOptions && !event.target.closest('.payment-options-container')) {
        setShowPaymentOptions(false);
      }
    };

    if (showPaymentOptions) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showPaymentOptions]);

  useEffect(() => {
    const now = new Date();
    const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true })}`;
    setCurrentDateTime(formattedDateTime);
  }, []);

  // Auto-focus hours input when time popup opens
  useEffect(() => {
    if (showTimePopup && hoursInputRef.current) {
      setTimeout(() => {
        hoursInputRef.current.focus();
      }, 100);
    }
  }, [showTimePopup]);


  const handleKeyDown = (e, nextFieldRef, fallbackRef = null) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextFieldRef?.current) {
        nextFieldRef.current.focus();
      } else if (fallbackRef?.current) {
        fallbackRef.current.focus();
      }
    } else if (e.key === "Help") {
      console.log('escapesss')
    }
  };

  useEffect(() => {
    getData();
    getHeaderData();

    const billigDate = new Date();
    const newdate = formatBilledDate(billigDate);
    setBilledDate(newdate);
  }, []);


  const isElectron = () => {
    return window && window.process && window.process.type;
  };

  let ipcRenderer;

  if (isElectron()) {
      ipcRenderer = window.require('electron').ipcRenderer;
  }

  const getData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}${GET_PATIENTS}`, {
        headers: {
          'PageNo': pageno,
          'PageSize': pagesize,
          'FilterText': '',
          'XApiKey': process.env.REACT_APP_API_KEY,
          'Authorization': `Bearer ${token}`
        },
      });

      if (response.status === 200) {
        setLoading(false)
        //setPatients(response.data.data.masterData);
        // if (id && edit && sequence) {
        //   getTestData();
        // }
      }
    } catch (error) {
      toast.error('Failed to fetch patient data.', {
        autoClose: 1000,
      });
    } finally {
      setLoading(false);
    }
  };

  const getHeaderData = async () => {
    setLoading(true);
    try {
      const response1 = await axios.get(`${BASE_URL}${BIIL_ENTRY_LOAD}`, {
        headers: {
          'XApiKey': process.env.REACT_APP_API_KEY,
          'Authorization': `Bearer ${token}`
        },
      });

      if (response1.status === 200) {
        setInvoiceNumber(response1.data.data.nextNum);
        setNewInvoiceNumber(response1.data.data.nextNum)
        setDoctors(response1.data.data.doctors);
        setItems(response1.data.data.items)

        // if (ids && edits) {
        //   setId(ids)
        //   setEdit(edits)
        //   getItemData(response1.data.data.items);
        // }
      }

    } catch (error) {
      toast.error('Failed to fetch header data.', {
        autoClose: 1000,
      });
    } finally {
      setLoading(false);
    }
  };

  const getItemDatasparms = async (prevnum) => {
    console.log('hereee insodee')
    setLoading(true);
    try {
      console.log('hereee', prevnum, sequence || ipcRenderer.invoke('store-get', 'finac_year'))
        const response = await axios.get(`${BASE_URL}${GET_GENERAL_BILLS}`, {
            headers: {
                'XApiKey': process.env.REACT_APP_API_KEY,
                'Authorization': `Bearer ${token}`,
                'sequence': ipcRenderer.invoke('store-get', 'finac_year') ,
                'invoiceNo' : prevnum.toString(),
                'editNo': 0,
                'groupby': 'Bill Wise',
                'searchKey': '',
                'fromDate' : '',
                'toDate' : '',
                'isforward': true
            },
        });

        // Parse the LineItemJson for each bill
        const parsedData = response.data.data.map(bill => {
          let lineItems = [];
          
          try {
              // Parse the LineItemJson string to JavaScript object
              lineItems = JSON.parse(bill.LineItemJson);
          } catch (error) {
              console.error('Error parsing LineItemJson:', error);
              lineItems = []; // fallback to empty array
          }
          
          return {
              ...bill,
              LineItems: lineItems, // Add parsed line items
              LineItemJson: undefined // Optional: remove the string version
          };
        });

        if (response.status === 200) {
            const headerData = parsedData[0];
            const lineData = parsedData[0].LineItems;
            setIsEditMode(true);

            setId(headerData.InvoiceNo)
            setEdit(headerData.EditNo)

            handleMobileChange(headerData.MobileNo)

            setSelectedPatient({
                PatientID: headerData.PatientID,
                PatientName: headerData.PatientName,
                Age: headerData.Age,
                MobileNo: headerData.MobileNo,
                Gender: headerData.Gender
            });

            // Update the mobileInput to match the selected patient's MobileNo
            setMobileInput(headerData.MobileNo || "");

            // Update other states
            setSelectedDoctor({ value: headerData.Ref_DoctorID, label: headerData.Ref_DoctorName });
            setInvoiceNumber(headerData.InvoiceNo);

            const updatedProducts = lineData.map((item, index) => {

              return {
                  id: item.ID,
                  item: { value: item.ID, label: item.Name, Category: item.Category },
                  rate: item.Rate,
                  amount: item.Amount,
                  type: '',
                  name: item.Name,
                  qty: item.Qty,
                  item_discount: 0,
                  category: item.Category || '', // Add Category from LineItemJson
              };
            });
            setProducts(updatedProducts);
            setInvoiceNumber(headerData.InvoiceNo);
            setPrevBalanceDue(headerData.BalanceDue);

            // Parse and store original bill date from Created_at
            if (headerData.Created_at) {
              try {
                const createdDate = new Date(headerData.Created_at);
                const formattedOriginalDate = formatBilledDate(createdDate);
                setOriginalBillDate(formattedOriginalDate);
                setBilledDate(formattedOriginalDate);
              } catch (error) {
                console.error('Error parsing Created_at date:', error);
                const billigDate = new Date();
                const newdate = formatBilledDate(billigDate);
                setBilledDate(newdate);
                setOriginalBillDate(null);
              }
            } else {
              const billigDate = new Date();
              const newdate = formatBilledDate(billigDate);
              setBilledDate(newdate);
              setOriginalBillDate(null);
            }
        }
    } catch (error) {
        toast.error('Failed to fetch patient data.', {
          autoClose: 1000,
        });
    } finally {
        setLoading(false);
    }
  };

  const getItemData = async () => {
    setLoading(true);
    try {
        const response = await axios.get(`${BASE_URL}${GET_GENERAL_BILLS}`, {
            headers: {
                'XApiKey': process.env.REACT_APP_API_KEY,
                'Authorization': `Bearer ${token}`,
                'sequence': sequence || ipcRenderer.invoke('store-get', 'finac_year'),
                'invoiceNo' : id,
                'editNo': 0,
                'groupby': 'Bill Wise',
                'searchKey': '',
                'fromDate' : '',
                'toDate' : '',
                'isforward': true
            },
        });

        // Parse the LineItemJson for each bill
        const parsedData = response.data.data.map(bill => {
          let lineItems = [];
          
          try {
              // Parse the LineItemJson string to JavaScript object
              lineItems = JSON.parse(bill.LineItemJson);
          } catch (error) {
              console.error('Error parsing LineItemJson:', error);
              lineItems = []; // fallback to empty array
          }
          
          return {
              ...bill,
              LineItems: lineItems, // Add parsed line items
              LineItemJson: undefined // Optional: remove the string version
          };
        });

        if (response.status === 200) {
            
            const headerData = parsedData[0];
            const lineData = parsedData[0].LineItems;
            handleMobileChange(headerData.MobileNo)

            setSelectedPatient({
                PatientID: headerData.PatientID,
                PatientName: headerData.PatientName,
                Age: headerData.Age,
                MobileNo: headerData.MobileNo,
                Gender: headerData.Gender
            });

            // Update the mobileInput to match the selected patient's MobileNo
            setMobileInput(headerData.MobileNo || "");

            // Update other states
            setSelectedDoctor({ value: headerData.Ref_DoctorID, label: headerData.Ref_DoctorName });
            setInvoiceNumber(headerData.InvoiceNo);

            const updatedProducts = lineData.map((item, index) => {

              return {
                  id: item.ID,
                  item: { value: item.ID, label: item.Name, Category: item.Category },
                  rate: item.Rate,
                  amount: item.Amount,
                  type: '',
                  name: item.Name,
                  qty: item.Qty,
                  item_discount: 0,
                  category: item.Category || '', // Add Category from LineItemJson
              };
            });
            setProducts(updatedProducts);
            setInvoiceNumber(headerData.InvoiceNo);
            setPrevBalanceDue(headerData.BalanceDue);

            if (headerData.Created_at) {
              try {
                const createdDate = new Date(headerData.Created_at);
                const formattedOriginalDate = formatBilledDate(createdDate);
                setOriginalBillDate(formattedOriginalDate);
                setBilledDate(formattedOriginalDate);
              } catch (error) {
                console.error('Error parsing Created_at date:', error);
                const billigDate = new Date();
                const newdate = formatBilledDate(billigDate);
                setBilledDate(newdate);
                setOriginalBillDate(null);
              }
            } else {
              const billigDate = new Date();
              const newdate = formatBilledDate(billigDate);
              setBilledDate(newdate);
              setOriginalBillDate(null);
            }
        }
    } catch (error) {
        toast.error('Failed to fetch patient data.', {
          autoClose: 1000,
        });
    } finally {
        setLoading(false);
    }
  };

  const handleMobileChange = async (inputValue) => {
    // Handle null, undefined, or empty values
    if (!inputValue || inputValue === null || inputValue === undefined) {
        setMobileInput('');
        setEditNumber('');
        seteditName('');
        return;
    }

    // Convert to string if it's not already (in case a number is passed)
    const value = String(inputValue);
    
    setMobileInput(value);
    const isNumeric = /^\d+$/.test(value);

    if (isNumeric) {
        setEditNumber(value);
        seteditName(''); // Clear name when number is entered
    } else {
        seteditName(value.toUpperCase());
        setEditNumber(''); // Clear number when text is entered
    }

    // Trigger filter on specific lengths
    if (value.length === 3 || value.length === 6 || value.length === 9 || value.length === 10) {
        await getFilterData(value);
    }
  };

  const getFilterData = async (inputValue) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}${GET_PATIENTS}`, {
        headers: {
          'PageNo': pageno,
          'PageSize': pagesize,
          'FilterText': inputValue,
          'XApiKey': process.env.REACT_APP_API_KEY,
          'Authorization': `Bearer ${token}`
        },
      });

      if (response.status === 200) {
        setPatients(response.data.data.masterData);
      }
    } catch (error) {
      toast.error('Failed to filter patients.', {
        autoClose: 1000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedPatient) {
      // Load default values into the edit state when a patient is selected
      seteditName(selectedPatient.PatientName || '');
      setEditNumber(selectedPatient.MobileNo || '');
      setEditAge(selectedPatient.Age || '');
      setEditGender(selectedPatient.Gender || '');
    }
  }, [selectedPatient]);

  const handleSuggestionClick = (selectedOption) => {
    if (selectedOption) {
      setSelectedPatient(selectedOption);
      setMobileInput(selectedOption.MobileNo || '');
    } else {
      setSelectedPatient(null);
      setMobileInput('');
    }
  };

  const options = patients.map(patient => ({
    value: patient.PatientID,
    label: `${patient.PatientName} - ${patient.Age} years - ${patient.Place} - ${patient.MobileNo}`,
    ...patient
  }));

  const doctors_options = doctors.map(doctor => ({
    value: doctor.DoctorID,
    label: doctor.Designation
      ? `${doctor.DoctorName}  ,  ${doctor.Designation}`
      : doctor.DoctorName
  }));


  const customOptionLabel = ({ PatientName, Age, Place, MobileNo }) => {
    return (
      <div className="flex items-center space-x-3 py-1">
        {PatientName && (
          <div className="font-semibold text-sm text-black">
            {PatientName}
          </div>
        )}
        {Age && (
          <div className="text-xs px-2 py-0.5 bg-indigo-50 text-black rounded-full">
            {Age} years
          </div>
        )}
        {Place && (
          <div className="text-xs text-black flex items-center">
            <FiMapPin className="mr-1" size={12} />
            {Place}
          </div>
        )}
        {MobileNo && (
          <div className="text-xs text-black flex items-center">
            <FiPhone className="mr-1" size={12} />
            {MobileNo}
          </div>
        )}
      </div>
    );
  };

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value); // Update the corresponding edit state
  };

  // Handler for Age change
  const handleAgeChange = (e) => {
    const age = e.target.value;
    setEditAge(age);
  };

  // Handle quantity changes - recalculate amount based on rate × qty
  const handleQtyChange = (index, newQty) => {
    if (newQty !== '' && parseFloat(newQty) < 0) {
      toast.error('Quantity cannot be negative.', { autoClose: 1000 });
      return;
    }
    const updatedProducts = products.map((product, i) => {
      if (i === index) {
        const rate = parseFloat(product.rate || 0);
        const newAmount = (parseFloat(newQty || 0) * rate).toFixed(2);
        
        return {
          ...product,
          qty: newQty,
          amount: newAmount
        };
      }
      return product;
    });
    setProducts(updatedProducts);
  };

  // Handle rate changes - recalculate amount based on rate × qty
  const handleRateChange = (index, newRate) => {
    if (newRate !== '' && parseFloat(newRate) < 0) {
      toast.error('Rate cannot be negative.', { autoClose: 1000 });
      return;
    }
    const updatedProducts = products.map((product, i) => {
      if (i === index) {
        const qty = parseFloat(product.qty || 1);
        const newAmount = (parseFloat(newRate || 0) * qty).toFixed(2);
        
        return {
          ...product,
          rate: newRate,
          amount: newAmount
        };
      }
      return product;
    });
    setProducts(updatedProducts);
  };


  // Handle amount changes - recalculate rate based on amount ÷ qty
  const handleAmountChange = (index, newAmount) => {
    if (newAmount !== '' && parseFloat(newAmount) < 0) {
      toast.error('Amount cannot be negative.', { autoClose: 1000 });
      return;
    }
    const updatedProducts = products.map((product, i) => {
      if (i === index) {
        const qty = parseFloat(product.qty || 1);
        const newRate = qty > 0 ? (parseFloat(newAmount || 0) / qty).toFixed(2) : '0.00';
        
        return {
          ...product,
          amount: newAmount,
          rate: newRate
        };
      }
      return product;
    });
    setProducts(updatedProducts);
  };

  const handleProductChange = (index, selectedOption) => {
    if (!selectedOption) return;
    
    // Check for duplicates
    const isDuplicate = products.some(product => product.id === selectedOption.value && product.type === selectedOption.type);
  
    if (isDuplicate) {
      toast.error("This test is already added.", { autoClose: 1000 });
      return;
    }

    // Check if the item starts with "OBSER"
    const isObserItem = selectedOption.label && selectedOption.label.toUpperCase().startsWith('OBSER');
    
    if (isObserItem) {
      // First set the item in the products array
      const newProducts = products.map((product, i) => {
        if (i === index) {
          return {
            id: selectedOption.value,
            item: selectedOption,
            rate: selectedOption.Rate || 0,
            amount: 0, // Will be calculated after time input
            type: selectedOption.type || '',
            name: selectedOption.label,
            qty: 1,
            item_discount: selectedOption.itemdiscount || 0,
            category: selectedOption.Category || '', // Add Category
            isObserItem: true, // Mark as OBSER item
            timeHours: 0,
            timeMinutes: 0,
          };
        }
        return product;
      });
      
      setProducts(newProducts);
      
      // Show time popup for OBSER items
      setTimePopupData({
        index: index,
        hours: 0,
        minutes: 0,
        baseRate: selectedOption.Rate || 0,
        itemName: selectedOption.label
      });
      setShowTimePopup(true);
      return; // Don't proceed with normal product change
    }
  
    const newProducts = products.map((product, i) => {
      if (i === index) {
        const defaultQty = 1;
        const rate = selectedOption.Rate || 0;
        const amount = (defaultQty * rate).toFixed(2);
        
        return {
          id: selectedOption.value,
          item: selectedOption,
          rate: rate, // Store rate separately
          amount: amount,
          type: selectedOption.type,
          name: selectedOption.label,
          qty: defaultQty,
          item_discount: selectedOption.itemdiscount || product.item_discount || 0,
          category: selectedOption.Category || '', // Add Category
          isObserItem: false, // Mark as non-OBSER item
        };
      }
      return product;
    });
  
    setProducts(newProducts);
   
    // Focus on rate field after item selection
    setTimeout(() => {
      if (rateRefs.current[index]) {
        rateRefs.current[index].focus();
        rateRefs.current[index].select();
      }
    }, 100);
   
    if (selectedOption && index === products.length - 1) {
      addTestRow();
    }
  };

  // Handle time popup confirmation
  const handleTimePopupConfirm = () => {
    const { index, hours, minutes, baseRate } = timePopupData;
    
    if (hours === 0 && minutes === 0) {
      toast.error("Please enter valid time duration.", { autoClose: 1000 });
      return;
    }

    const calculatedAmount = calculateTimeBasedAmount(baseRate, hours, minutes);
    
    const newProducts = products.map((product, i) => {
      if (i === index) {
        return {
          id: product.item?.value,
          item: product.item,
          rate: baseRate,
          amount: calculatedAmount.toFixed(2),
          type: product.item?.type || '',
          name: product.item?.label || '',
          qty: 1, // Fixed qty for OBSER items
          item_discount: product.item_discount || 0,
          category: product.item?.Category || product.category || '', // Add Category
          isObserItem: true, // Mark as OBSER item
          timeHours: hours,
          timeMinutes: minutes,
        };
      }
      return product;
    });

    setProducts(newProducts);
    setShowTimePopup(false);
    
    // Focus on the next item selection after confirming time popup
    setTimeout(() => {
      const nextIndex = index + 1;
      if (nextIndex < products.length && productRefs.current[nextIndex]) {
        productRefs.current[nextIndex].focus();
      } else if (nextIndex === products.length) {
        // Last row, add new row and focus on it
        addTestRow();
        setTimeout(() => {
          if (productRefs.current[nextIndex]) {
            productRefs.current[nextIndex].focus();
          }
        }, 150);
      }
    }, 100);
  };

  // Handle time popup cancellation
  const handleTimePopupCancel = () => {
    setShowTimePopup(false);
    setTimePopupData({
      index: null,
      hours: 0,
      minutes: 0,
      baseRate: 0,
      itemName: ''
    });
  };
  
  
  const addTestRow = () => {
    setProducts(prevProducts => [...prevProducts, { item: null, amount: "", id: null, type: "", name: "" }]);

    setTimeout(() => {
      productRefs.current[products.length]?.focus();
    }, 100);
  };
  

  const handleDeleteRow = (index) => {

    const newProducts = products.filter((_, i) => i !== index);
    setProducts(newProducts);
  };

  const itemOptions = items.map(item => ({
    value: item.ItemNo,
    label: item.ItemName, // This can remain as the Name
    TestCode: item.ItemCode, // Add TestCode
    Rate: item.Rate, // Add Rate
    Category: item.Category, // Add Category
    amount: item.Rate,
    qty: 1,
  }));
  
  const customItemOptionLabel = ({ label, TestCode, Rate }) => (
    <div className="flex flex-col">
      <span className="font-bold text-black text-sm">{label}</span>
    </div>
  );

  const calculateTotal = () => {
    return products.reduce((total, product) => total + parseFloat(product.amount || 0.00), 0.00).toFixed(2);
  };

  // Time-based billing calculation for OBSER items
  const calculateTimeBasedAmount = (baseRate, hours, minutes) => {
    const totalMinutes = (hours * 60) + minutes;
    
    // If time is 0 or negative, return 0
    if (totalMinutes <= 0) {
      return 0;
    }
    
    // Calculate which 2-hour period we're in (round up)
    const twoHourPeriod = Math.ceil(totalMinutes / 120);
    
    // Calculate amount: base rate × period number
    const amount = baseRate * twoHourPeriod;
    
    return parseFloat(amount.toFixed(2));
  };

  const formatISTDate = () => {
    // Use local timezone (IST) components directly instead of UTC
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
    const timezoneOffset = "+05:30";
  
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${timezoneOffset}`;
  };


  const resetForm = async () => {
    // Use startTransition to batch all state updates for better performance
    startTransition(() => {
      // Reset patient information
      setSelectedPatient(null);
      setMobileInput('');
      setSelectedDoctor("");
      
      // Reset form fields
      seteditName('');
      setEditNumber('');
      setEditAge('');
      setEditGender('');
      setSearchOpnum('');
      loadedOpnumRef.current = '';
      
      // Reset products to initial state
      setProducts([{ item: null, amount: "", type: "", qty: 1, id: null, name: "", item_discount: 0, rate: 0 }]);
      
      // Reset payment and amounts
      setPayingAmount(0);
      setPrevBalanceDue(0);
      setPaymentMode('Cash');
      
      // Reset edit mode and IDs
      setIsEditMode(false);
      setId('');
      setEdit('');
      setOriginalBillDate(null);
      
      // Reset selected index
      setSelectedIndex(null);
      
      // Reset time popup if open
      setShowTimePopup(false);
      setTimePopupData({
        index: null,
        hours: 0,
        minutes: 0,
        baseRate: 0,
        itemName: ''
      });
      
      // Reset button state
      setIsButtonDisabled(false);
      setShowPaymentOptions(false);
    });

    // Clear refs arrays synchronously
    isSavingRef.current = false;
    productRefs.current = [];
    rateRefs.current = [];
    qtyRefs.current = [];
    amountRefs.current = [];

    // Set current billed date
    const billigDate = new Date();
    const newdate = formatBilledDate(billigDate);
    setBilledDate(newdate);
    
    // Get new invoice number without showing loading spinner
    try {
      const response = await axios.get(`${BASE_URL}${BIIL_ENTRY_LOAD}`, {
        headers: {
          'XApiKey': process.env.REACT_APP_API_KEY,
          'Authorization': `Bearer ${token}`
        },
      });

      if (response.status === 200) {
        setInvoiceNumber(response.data.data.nextNum);
        setNewInvoiceNumber(response.data.data.nextNum);
        // Also update doctors and items in case they changed
        setDoctors(response.data.data.doctors);
        setItems(response.data.data.items);
      }
    } catch (error) {
      console.error('Failed to fetch new invoice number:', error);
    }
    
    // Focus on op number field
    setTimeout(() => {
      setLoading(false);
      setIsButtonDisabled(false);
      opnumRef.current?.focus();
    }, 100);
  };


  const handleSave = async () => {
    if (isEditMode && !canEditOpBill) {
      toast.error("You don't have permission to edit OP bills.", { autoClose: 1400 });
      return;
    }

    // Prevent double submission
    if (isSavingRef.current) {
      return;
    }

    // Set saving flag immediately
    isSavingRef.current = true;
    setIsButtonDisabled(true);
    setLoading(true)

    // Update billedDate to current date/time before saving (new/modified bill)
    const billigDate = new Date();
    const newdate = formatBilledDate(billigDate);
    setBilledDate(newdate);
    setOriginalBillDate(null); // Clear original date since this is a new/modified bill

    // If OP number was changed without Enter/blur completing, load details before save
    const currentOp = (searchOpnum || '').trim();
    let patientForSave = selectedPatient;
    let doctorForSave = selectedDoctor;
    let nameForSave = editName || nameRef.current?.value;
    let numberForSave = editNumber;
    let ageForSave = editAge;
    let genderForSave = editGender;

    if (currentOp && currentOp !== String(loadedOpnumRef.current).trim()) {
      const opResult = await handleOpSearch({ focusNext: false });
      if (!opResult?.ok) {
        toast.error('Could not load OP details. Please check the OP number.', { autoClose: 2000 });
        setLoading(false);
        setIsButtonDisabled(false);
        isSavingRef.current = false;
        opnumRef.current?.focus();
        return;
      }
      if (opResult.patient) {
        patientForSave = opResult.patient;
        nameForSave = opResult.patient.PatientName || nameForSave;
        numberForSave = opResult.patient.MobileNo || numberForSave;
        ageForSave = opResult.patient.Age || ageForSave;
        genderForSave = opResult.patient.Gender || genderForSave;
      }
      if (opResult.doctor) {
        doctorForSave = opResult.doctor;
      }
    }
  
    const currentName = nameForSave;

    if(currentName === ''){
      toast.error('Name is required.', { autoClose: 1000 });
      setLoading(false)
      setIsButtonDisabled(false);
      isSavingRef.current = false; // Reset flag on early return
      nameRef.current.focus()
      return;
    }
    
    const validProducts = products.filter(product => product.id && product.name);
    
    if(validProducts.length === 0){
      toast.error('Please select items.', { autoClose: 1000 });
      setLoading(false)
      setIsButtonDisabled(false);
      isSavingRef.current = false; // Reset flag on early return
      if (productRefs.current[0]) {
        productRefs.current[0].focus();
      }
      return;
    }

    const payingAmt = parseFloat(payingAmount || 0);
    if (payingAmt < 0) {
      toast.error('Paying amount cannot be negative.', { autoClose: 1400 });
      setLoading(false);
      setIsButtonDisabled(false);
      isSavingRef.current = false;
      return;
    }

    const hasNegativeLine = validProducts.some((product) => {
      return parseFloat(product.qty || 0) < 0
        || parseFloat(product.rate || 0) < 0
        || parseFloat(product.amount || 0) < 0;
    });
    if (hasNegativeLine) {
      toast.error('Quantity, rate and amount cannot be negative.', { autoClose: 1400 });
      setLoading(false);
      setIsButtonDisabled(false);
      isSavingRef.current = false;
      return;
    }

    if(id){
      console.log('hereee iddd', id, edit, sequence)
      const validProducts = products.filter(product => product.id && product.name);

      if( validProducts.length === 0){
        toast.error('Please Select Items.', { autoClose: 1000 });
        setLoading(false);
        setIsButtonDisabled(false);
        isSavingRef.current = false; // Reset flag on validation error
        return;
      } else {
        setIsButtonDisabled(true);
        setLoading(true);

        const parseDecimal = (value) => parseFloat(parseFloat(value).toFixed(3));
        const entrydate = formatISTDate();

        const balanceDue = (calculateTotal() - (parseFloat(payingAmount) || 0) );

        const paymentStatus = balanceDue === 0 ? "Completed" : "Pending";

      
        const testEtryHdr = {
          OpNumber: currentOp || '',
          PatientID: patientForSave?.PatientID || 0,
          PatientName: nameForSave || "",
          MobileNo: numberForSave || "",
          Age: ageForSave || 0,
          Gender: genderForSave || "",
          EntryDate: entrydate,
          Ref_DoctorID: doctorForSave?.value || 0,
          Ref_DoctorName: doctorForSave?.label || "",
          PaymentMode: paymentMode,
          PaymentStatus: paymentStatus,
          CashAmount: paymentMode === "Cash" ? parseFloat(payingAmount || 0) : 0.00,
          BankAmount: paymentMode === "Bank" ? parseFloat(payingAmount || 0) : 0.00,
          //AdvanceAmount: advance,
          BalanceDue: (calculateTotal() - (parseFloat(payingAmount) || 0) ),
          TotalAmount: parseDecimal(calculateTotal()),
          GrandTotal: parseDecimal(calculateTotal()),
          Discount: 0,
        };
      
        const testEntryLines = validProducts.map((product, index) => ({
          SI_No: index + 1,
          Id: product?.id || '', 
          Name: product?.item?.label || 'Unknown',
          Amount: parseDecimal(product?.amount || "0.00"),
          Qty: parseInt(product?.qty) || 0,
          Rate: parseInt(product.rate) || 0,
          Category: product?.category || product?.item?.Category || '', // Add Category
        }));
      
        const payload = {
          generalBillEtryHdr: testEtryHdr,
          generalBillEntryLines: testEntryLines
        };
  
        try {
  
          const response = await axios.post(`${BASE_URL}${POST_BILL_ENTRY}`, payload, {
            headers: {
              'XApiKey': process.env.REACT_APP_API_KEY,
              'Authorization': `Bearer ${token}`,
              'InvoiceNo': id,
              'Sequence': sequence,
              'EditNo': edit,
              'DocStatus': 'U',
            },
          });
      
          if (response.status === 200) {
            toast.success('Invoice Created Successfully', { duration: 1000 });

            // handleputPatient();

            if (printAfterSave) {
              handlePrint();
            }

            setTimeout(() => {
              resetForm();
              getData();
  
              setLoading(false);
              setIsButtonDisabled(false);
              isSavingRef.current = false; // Reset flag on success
            }, 1000);
            
            
          } else {
            toast.error('Something Went Wrong', { duration: 1000 });
            setLoading(false);
            setIsButtonDisabled(false);
            isSavingRef.current = false; // Reset flag on error
          }
        } catch (error) {
          console.error(error);
          toast.error('Something Went Wrong', { duration: 1000 });
          setLoading(false);
          setIsButtonDisabled(false);
          isSavingRef.current = false; // Reset flag on catch
        }
      }      
    } else{
      console.log('hereee insideeee')
      let InvoiceNo = 0;

      try {
        const response1 = await axios.get(`${BASE_URL}${BIIL_ENTRY_LOAD}`, {
          headers: {
            'XApiKey': process.env.REACT_APP_API_KEY,
            'Authorization': `Bearer ${token}`
          },
        });
  
        if (response1.status === 200) {
          InvoiceNo = response1.data.data.nextNum;
          setInvoiceNumber(response1.data.data.nextNum);
          setNewInvoiceNumber(response1.data.data.nextNum)
        }
      } catch (error) {
        setLoading(false)
        setIsButtonDisabled(false);
        isSavingRef.current = false; // Reset flag on error
        toast.error('Failed to fetch header data.', {
          autoClose: 1000,
        });
        return;
      }
      const validProducts = products.filter(product => product.id && product.name);

      if( validProducts.length === 0){
        toast.error('Please Select Tests.', { autoClose: 1000 });
        setLoading(false);
        setIsButtonDisabled(false);
        isSavingRef.current = false; // Reset flag on validation error
        return;
      } else {
        setLoading(true);
  
        setIsButtonDisabled(true);
        
        const parseDecimal = (value) => parseFloat(parseFloat(value).toFixed(3));
        const entrydate = formatISTDate();

        const balanceDue = (calculateTotal() - (parseFloat(payingAmount) || 0) );

        const paymentStatus = balanceDue === 0 ? "Completed" : "Pending";

      
        const testEtryHdr = {
          OpNumber: currentOp || '',
          PatientID: patientForSave?.PatientID || 0,
          PatientName: nameForSave || "",
          MobileNo: numberForSave || "",
          Age: ageForSave || 0,
          Gender: genderForSave || "",
          EntryDate: entrydate,
          Ref_DoctorID: doctorForSave?.value || 0,
          Ref_DoctorName: doctorForSave?.label || "",
          PaymentMode: paymentMode,
          PaymentStatus: paymentStatus,
          CashAmount: paymentMode === "Cash" ? parseFloat(payingAmount || 0) : 0.00,
          BankAmount: paymentMode === "Bank" ? parseFloat(payingAmount || 0) : 0.00,
          //AdvanceAmount: advance,
          BalanceDue: (calculateTotal() - (parseFloat(payingAmount) || 0) ),
          TotalAmount: parseDecimal(calculateTotal()),
          GrandTotal: parseDecimal(calculateTotal()),
          Discount: 0,
        };
      
        const testEntryLines = validProducts.map((product, index) => ({
          SI_No: index + 1,
          Id: product?.id || '', 
          Name: product?.item?.label || 'Unknown',
          Amount: parseDecimal(product?.amount || "0.00"),
          Qty: parseInt(product?.qty) || 0,
          Rate: parseInt(product.rate) || 0,
          Category: product?.category || product?.item?.Category || '', // Add Category
        }));
      
        const payload = {
          generalBillEtryHdr: testEtryHdr,
          generalBillEntryLines: testEntryLines
        };
  
        try {
          const response = await axios.post(`${BASE_URL}${POST_BILL_ENTRY}`, payload, {
            headers: {
              'XApiKey': process.env.REACT_APP_API_KEY,
              'Authorization': `Bearer ${token}`,
              'InvoiceNo': InvoiceNo || invoiceNumber,
              'Sequence': sequence,
              'EditNo': edit,
              'DocStatus': 'A',
            },
          });
      
          if (response.status === 200) {
            toast.success('Invoice Created Successfully', { duration: 1000 });

            // handleputPatient();
  
            if (printAfterSave) {
              handlePrint();
            }

            setTimeout(() => {
              resetForm();
              getData();
  
              setLoading(false);
  
              setIsButtonDisabled(false);
              isSavingRef.current = false; // Reset flag on success
            }, 1500);
            
            
          } else {
            toast.error('Something Went Wrong', { duration: 1000 });
            setLoading(false);
  
            setIsButtonDisabled(false);
            isSavingRef.current = false; // Reset flag on error
          }
        } catch (error) {
          console.error(error);
          toast.error('Something Went Wrong', { duration: 1000 });
          setLoading(false);
          setIsButtonDisabled(false);
          isSavingRef.current = false; // Reset flag on catch
        }
      }
    }
  };


  const printKOT = async () => {

    try {
      // Filter valid products for KOT
      const validProducts = products.filter(product => product.id && product.name);

      const calculateTotal = () => {
        // Assuming 'amount' is the total for line item. 
        return validProducts.reduce((sum, product) => sum + parseFloat(product.amount || 0), 0).toFixed(2);
      };

      const data = {
        settings: {
          printerType: 'KOT'
        },
        header: {
          firmName: `${generalsettings?.FirstName || ""} ${generalsettings?.LastName || ""}`.trim(),
          address: [
            generalsettings?.AddressLine1,
            generalsettings?.AddressLine2,
            generalsettings?.Place
          ].filter(Boolean),
          phones: [
            generalsettings?.MobileNo1,
            generalsettings?.MobileNo2
          ].filter(Boolean),
          invoiceNumber: String(invoiceNumber || ""),
          date: formatBilledDate(new Date()),
          patientName: selectedPatient?.PatientName || "",
          age: selectedPatient?.Age ? String(selectedPatient.Age) : "",
          gender: selectedPatient?.Gender || "",
          mobile: selectedPatient?.MobileNo || "",
          doctor: selectedDoctor?.label || "",
          username: userInfo?.username || "Admin"
        },
        products: validProducts.map((p, i) => ({
          sr: i + 1,
          name: p.alt_name || p.name || "",
          qty: parseInt(p.qty || 0),
          total: parseFloat(p.amount || 0)
        })),
        totals: {
          totalAmount: parseFloat(calculateTotal()),
          balance: id
            ? parseFloat(prevBalanceDue || 0)
            : parseFloat(calculateTotal() - (parseFloat(payingAmount) || 0)),
          paid: id
            ? parseFloat(calculateTotal() - (prevBalanceDue || 0))
            : parseFloat(payingAmount || 0)
        }
      };

      await ipcRenderer.invoke('opbill-kot', {
        printerName: sysInfo.OpBillPrinter,
        json: data
      });

      toast.success('KOT printed successfully!', { duration: 1000 });
      setLoading(false);

    } catch (error) {
      console.error('Failed to print KOT:', error);
      toast.error('Failed to print KOT.', {
        autoClose: 1000,
      });
      setLoading(false);
    }
  };

  const handlePrint = async () => {
    if(generalsettings?.GbBillType === 'KOT'){
      printKOT();
    } else if(generalsettings?.GbBillType === 'DOTMATRIX'){
      if (normalBillPrintRef.current) {
        await normalBillPrintRef.current.handleRawTextPrint();
      }
    } else {
      if(isElectron()){
        if(!sysInfo.OpBillPrinter){
          toast.error('Cannot Print,Printer Not Selected ', { duration: 1000 });
        } else {
           const billDiv = document.getElementById('billDiv');
  
          if (billDiv) {
            const promises = [];
            
            // Iterate through all pages and convert each one to an image
            for (let i = 1; i <= totalPages; i++) {
              // Set the current page
              setCurrentPage(i);
              
              // Wait longer and use multiple methods to ensure rendering is complete
              await new Promise((resolve) => {
                setTimeout(() => {
                  // Use requestAnimationFrame to ensure DOM has updated
                  requestAnimationFrame(() => {
                    // Additional small delay to ensure all data is rendered
                    setTimeout(resolve, 200);
                  });
                }, 800); // Increased from 600ms to 800ms
              });

              // Verify that the page has actually updated by checking if products are rendered
              const productElements = billDiv.querySelectorAll('[data-testid="product-row"]'); // You'll need to add this data attribute
              
              // Capture the image
              const dataUrl = await toPng(billDiv, { 
                quality: 1, 
                pixelRatio: 3,
                backgroundColor: '#ffffff' // Ensure white background
              });
              promises.push(dataUrl);
              
            }

            // Set up the listener BEFORE sending the event
            if(isElectron()){
              ipcRenderer.once('print-success', async (event, { status, error }) => {
                if (status === 'success') {
                  console.log('Print success:', status);
                } else {
                  console.error('Print failed:', error);
                  toast.error('Print failed. Please check your printer settings.', {
                    autoClose: 1000,
                  });
                }
              });
            } else{
              toast.error('Not Allowed', { duration: 1000 });
            }

            // Send the print event after setting up the listener
            try {
              const images = await Promise.all(promises);
              let pagesPrinted = 0;
              const totalPagesToPrint = images.length;
              
              images.forEach((imgDataUrl, index) => {
                ipcRenderer.send('print-bill-image', {
                  imgDataUrl,
                  printer: sysInfo.OpBillPrinter,
                });
                pagesPrinted++;

                if(pagesPrinted === totalPagesToPrint){
                  setTimeout(() => {
                    resetForm();
                    getData();
                    setLoading(false);
                  }, 3000);
                }
              });
            } catch (error) {
              console.error('Print preparation failed:', error);
              toast.error('Failed to prepare pages for printing.', {
                autoClose: 1000,
              });
              setLoading(false);
            }
          }
        }
      } 
    }
  };


  const formatDate = (dateString) => {
    if (!dateString) return '';  // Return empty string if dateString is null or undefined
  
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {  // Check if the date is invalid
      console.error('Invalid date:', dateString);
      return '';  // Return empty string if invalid date
    }
  
    // Use local timezone instead of UTC to preserve IST date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;  // Return the formatted date if valid (YYYY-MM-DD in local timezone)
  };

  const handleOpSearch = async ({ focusNext = true } = {}) => {
    const opToLoad = (searchOpnum || '').trim();

    if (opToLoad === '') {
      loadedOpnumRef.current = '';
      if (focusNext) {
        mobileInputRef.current?.focus();
      }
      return { ok: true };
    }

    if (opToLoad === String(loadedOpnumRef.current).trim()) {
      if (focusNext) {
        const lastIndex = products.length - 1;
        if (productRefs.current[lastIndex]) {
          productRefs.current[lastIndex].focus();
        }
      }
      return { ok: true, alreadyLoaded: true };
    }

    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}${GET_OP_DETAILS}`, {
        headers: {
          'Sequence': 0,
          'InvoiceNo': opToLoad,
          'EditNo': 0,
          'XApiKey': process.env.REACT_APP_API_KEY,
          'Authorization': `Bearer ${token}`
        },
      });

      if (response.status === 200) {
        setLoading(false)

        const patientData = response.data.data[0]
        if (!patientData) {
          toast.error('No patient found for this OP number.', { autoClose: 1000 });
          return { ok: false };
        }

        const doctorobj = doctors_options.find(doctor => doctor.value === patientData.Ref_DoctorID);

        const patient = {
          PatientID: patientData.PatientID,
          PatientName: patientData.PatientName,
          Age: patientData.Age,
          Place: patientData.Place,
          MobileNo: patientData.MobileNo,
          DOB: formatDate(patientData.DOB),
          Month: patientData.Month,
          Days: patientData.Days,
          Gender: patientData.Gender,
          opnum: opToLoad,
        };

        setSearchOpnum(opToLoad);
        loadedOpnumRef.current = opToLoad;
        setSelectedPatient(patient)
        setMobileInput(patientData.MobileNo || "");
        setSelectedDoctor(doctorobj)

        if (focusNext) {
          const lastIndex = products.length - 1;
          if (productRefs.current[lastIndex]) {
            productRefs.current[lastIndex].focus();
          }
        }
        return { ok: true, patient, doctor: doctorobj };
      }
      return { ok: false };
    } catch (error) {
      toast.error('Failed to fetch patient data.', {
        autoClose: 1000,
      });
      if (focusNext) {
        nameRef.current?.focus();
      }
      return { ok: false };
    } finally {
      setLoading(false);
    }

  }

  // Reload OP details when user leaves the field after changing the number
  const handleOpnumBlur = () => {
    const current = (searchOpnum || '').trim();
    if (!current) {
      loadedOpnumRef.current = '';
      return;
    }
    if (current === String(loadedOpnumRef.current).trim()) {
      return;
    }
    handleOpSearch({ focusNext: false });
  };

  const handleNext = async () => {
    const nextnum = parseInt(invoiceNumber) + 1
    if(newinvoiceNumber <= nextnum) {
      resetForm()
    } else {
      getItemDatasparms(nextnum, 0)
    }
    
  }

  const handleGoToInvoice = async (inputValue) => {
    console.log('Input value:', inputValue);
    getItemDatasparms(inputValue, 0)
    // Your logic here with the inputValue
  }

  const handlePrevious = async () => {

    const prevnum = parseInt(invoiceNumber) - 1
    if(prevnum === 0) {
      console.log(prevnum)
    } else {
      getItemDatasparms(prevnum, 0)
    }
  }


  return (
    <div className='flex h-full bg-background overflow-hidden'>

      <ToastContainer
        position="top-center"
        autoClose={1000}
        limit={1}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
      />
          
      {loading && <Spinner />}

      <div className='flex-1 flex h-full flex-col overflow-hidden hide-scrollbar'>

        <div className="bg-white p-3 mb-5">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-lg font-bold text-black flex items-center">
                New General Billing
              </h1>
              <p className="text-xs text-black ">{currentDateTime || new Date().toLocaleString()}</p>
            </div>
            <div className="flex items-center gap-3">
              {/* Navigation Buttons */}
              <div className="flex items-center gap-1">
                {((ids && edits && sequences) || isEditMode) && (
                  <button
                    type="button"
                    className="px-4 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium text-sm rounded-md hover:from-indigo-700 hover:to-purple-700 shadow-sm transition-all"
                    title="Print Invoice"
                    onClick={handlePrint}
                  >
                    <FiPrinter className="w-4 h-4" />
                  </button>
                )}
                <button
                  type="button"
                  className="p-1.5 bg-white text-gray-600 rounded-lg hover:bg-gray-50 hover:text-indigo-600 shadow-sm transition-colors border border-black"
                  title="Previous Invoice"
                  onClick={handlePrevious}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <input
                  type="text"
                  className="w-16 px-2 py-1.5 text-center text-sm border border-black rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 font-bold text-black"
                  placeholder="Invoice #"
                  defaultValue={invoiceNumber}
                  onFocus={(e) => e.target.select()} 
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleGoToInvoice(e.target.value);
                    }
                  }}
                />
                <button
                  type="button"
                  className="p-1.5 bg-white text-gray-600 rounded-lg hover:bg-gray-50 hover:text-indigo-600 shadow-sm transition-colors border border-black"
                  title="Next Invoice"
                  onClick={handleNext}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white ml-3 mr-3 rounded-lg shadow-sm p-3">
          <div className='w-full flex p-3 bg-gray-100 rounded-lg border border-gray-200 flex-col gap-2.5'>

            {/* Patient Info Section - Compact Header */}
            <div className="flex items-center gap-2 pb-2 border-b border-gray-300">
              <FiUser className="text-indigo-600" size={16} />
              <h3 className="font-semibold text-black text-sm">Patient Information</h3>
            </div>

              
            {/* Compact Grid Layout for Patient Fields */}
            <div className='w-full'>
              <div className='grid grid-cols-12 gap-2.5'>
                
                {/* Op Number - Compact */}
                <div className='col-span-2'>
                  <label className="block text-xs font-medium text-black mb-1">
                    Op Number
                  </label>
                  <input
                    type="text"
                    placeholder="Enter op number"
                    className="w-full p-1.5 pl-2 border border-gray-400 bg-white rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500 transition-colors text-sm"
                    ref={opnumRef}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleOpSearch();
                      }
                    }}
                    onBlur={handleOpnumBlur}
                    value={searchOpnum}
                    onChange={e => setSearchOpnum(e.target.value)}
                  />
                </div>

                <div className='col-span-4'>
                  <label className="block text-xs font-medium text-black mb-1">
                    Mobile Number / Name <span className="text-red-500">*</span>
                  </label>
                  <Select
                    placeholder="Enter mobile or name..."
                    inputId="mobile-input"
                    value={options.find(option => option.value === selectedPatient?.PatientID)}
                    options={options}
                    formatOptionLabel={customOptionLabel}
                    onInputChange={(value, { action }) => {
                      if (action === 'input-change') {
                        handleMobileChange(value);
                      }
                    }}
                    onChange={(selectedOption) => {
                      handleSuggestionClick(selectedOption);
                    }}
                    ref={mobileInputRef}
                    onMenuClose={() => {
                      setTimeout(() => {
                        nameRef.current?.focus();
                      }, 100);
                    }}
                    isClearable
                    noOptionsMessage={() => "No matches found"}
                    styles={customSelectStyles}
                    className="w-full"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const isMenuOpen = mobileInputRef.current?.state?.menuIsOpen;
                        const focusedOption = mobileInputRef.current?.state?.focusedOption;
                        
                        if (!isMenuOpen && !focusedOption) {
                          e.preventDefault();
                          nameRef.current?.focus();
                        } 
                      }
                    }}
                  />
                </div>

                {/* Name */}
                <div className='col-span-2'>
                  <label className="block text-xs font-medium text-black mb-1">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter patient name"
                    className="w-full p-1.5 pl-2 border border-gray-400 bg-white rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500 transition-colors text-sm"
                    ref={nameRef}
                    onKeyDown={(e) => handleKeyDown(e, numberRef)}
                    value={editName}
                    onChange={(e) => seteditName(e.target.value.toUpperCase())}
                  />
                </div>

                <div className='col-span-2'>
                  <label className="block text-xs font-medium text-black mb-1">
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter patient number"
                    className="w-full p-1.5 pl-2 border border-gray-400 bg-white rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500 transition-colors text-sm"
                    ref={numberRef}
                    onKeyDown={(e) => handleKeyDown(e, ageRef)}
                    value={editNumber}
                    onChange={handleInputChange(setEditNumber)}
                  />
                </div>

                <div className='col-span-2'>
                  <label className="block text-xs font-medium text-black mb-1">
                    Age <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    className="w-full p-1.5 pl-2 border border-gray-400 bg-white rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500 transition-colors text-sm"
                    value={editAge}
                    onChange={handleAgeChange}
                    ref={ageRef}
                    onKeyDown={(e) => handleKeyDown(e, GenderRef)}
                  />
                </div>

                <div className='col-span-2'>
                  <label className="block text-xs font-medium text-black mb-1">
                    Gender <span className="text-red-500">*</span>
                  </label>
                  <select
                    className="w-full p-2 pl-2 border border-gray-400 bg-white rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500 transition-colors text-sm"
                    value={editGender}
                    onChange={handleInputChange(setEditGender)}
                    ref={GenderRef}
                    onKeyDown={(e) => handleKeyDown(e, doctorSelectRef)}
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                {/* Doctor */}
                <div className='col-span-4'>
                  <label className="block text-xs font-medium text-black mb-1">
                    Referring Doctor <span className="text-red-500">*</span>
                  </label>
                  <Select
                    options={doctors_options}
                    className="w-full font-medium"
                    isSearchable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    required
                    value={selectedDoctor}
                    ref={doctorSelectRef}
                    onMenuClose={() => {
                      if (productRefs.current[0]) {
                        productRefs.current[0].focus();
                      }
                    }}
                    onChange={setSelectedDoctor}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const isMenuOpen = doctorSelectRef.current?.state?.menuIsOpen;
                        const focusedOption = doctorSelectRef.current?.state?.focusedOption;
                        
                        if (!isMenuOpen && !selectedDoctor && !focusedOption) {
                          e.preventDefault();
                          if (productRefs.current[0]) {
                            productRefs.current[0].focus();
                          }
                        }
                      }
                    }}
                    inputId="doctor-input"
                    styles={customSelectStyles}
                  />
                </div>
                
              </div>
            </div>

          </div>
        </div>

        <div className="mt-2 flex-1 overflow-hidden flex flex-col ml-3 mr-3">
          <div className="flex justify-between items-center mb-2 pb-1.5 border-b border-black">
            <h3 className="font-semibold text-black text-sm">Item Selection</h3>
            <button 
              type="button"
              className="px-3 py-1.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium text-sm rounded-md hover:from-indigo-700 hover:to-purple-700 shadow-sm transition-all"
              onClick={addTestRow}
            >
              <FiPlus size={16} className="inline mr-1" />
              Add Item
            </button>
          </div>
          
          <div className="overflow-x-auto rounded-lg border border-gray-400 flex-1 w-full">
            <div className="overflow-y-auto overflow-x-auto border rounded-xl relative bg-white h-full">
              <table className="border-collapse text-xs w-full" style={{ minWidth: '1200px' }}>
                <thead className="bg-gray-200 text-left sticky top-0 z-10">
                  <tr>
                    <th className="px-3 py-2.5 text-sm font-medium text-black border border-gray-300 whitespace-nowrap" style={{ minWidth: '50px' }}>No.</th>
                    <th className="px-3 py-2.5 text-sm font-medium text-black border border-gray-300 whitespace-nowrap" style={{ minWidth: '330px' }}>Item Name</th>
                    <th className="px-3 py-2.5 text-sm font-medium text-black border border-gray-300 whitespace-nowrap" style={{ minWidth: '100px' }}>Qty</th>
                    <th className="px-3 py-2.5 text-sm font-medium text-black border border-gray-300 whitespace-nowrap" style={{ minWidth: '100px' }}>Rate</th>
                    <th className="px-3 py-2.5 text-sm font-medium text-black border border-gray-300 whitespace-nowrap" style={{ minWidth: '100px' }}>Amount</th>
                    <th className="px-3 py-2.5 text-sm font-medium text-black border border-gray-300 whitespace-nowrap" style={{ minWidth: '80px' }}>Action</th>
                  </tr>
                </thead>
                          
                <tbody className="bg-white">
                  {products.length > 0 ? (
                    products.map((product, index) => (
                      <tr 
                        key={index} 
                        className={`border-b border-gray-300 ${
                          selectedIndex === index && edit 
                            ? "bg-indigo-50" 
                            : "hover:bg-gray-50"
                        } transition-colors`}
                        onClick={() => setSelectedIndex(index)}
                      >                
                        <td className="px-3 py-2.5 text-sm text-black border border-gray-200 whitespace-nowrap">
                          {index + 1}
                        </td>
                        
                        <td className="px-3 py-1.5 border border-gray-200" style={{ minWidth: '330px' }}>
                          <Select
                            options={itemOptions}
                            className="w-full"
                            isSearchable
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={product.item}
                            formatOptionLabel={customItemOptionLabel}
                            onChange={(selectedOption) => handleProductChange(index, selectedOption)}
                            filterOption={(option, inputValue) => {
                              const searchValue = inputValue.toLowerCase();
                              
                              // Check if label exists and matches
                              const labelMatch = option.label && option.label.toLowerCase().includes(searchValue);
                              
                              // Check if TestCode exists and matches
                              const testCodeMatch = option.data && 
                                option.data.TestCode && 
                                option.data.TestCode.toLowerCase() === searchValue;
                              
                              return labelMatch || testCodeMatch;
                            }}      
                            
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                // Get the current menu state
                                const selectInstance = productRefs.current[index];
                                const isMenuOpen = selectInstance?.state?.menuIsOpen;
                                const focusedOption = selectInstance?.state?.focusedOption;
                                
                                // Only move focus if menu is closed AND no option is focused
                                // This means user pressed Enter on an empty/closed select
                                if (!isMenuOpen && !focusedOption) {
                                  e.preventDefault();
                                  submitbtnRef.current.focus();
                                }
                                // If menu is open or option is focused, let react-select handle the selection
                                // Don't interfere with the natural selection process
                              }
                            }}
                            required
                            ref={(el) => (productRefs.current[index] = el)}
                            styles={customSelectStyles}
                          />
                        </td>

                        <td className="px-3 py-1.5 text-xs border border-gray-200" style={{ minWidth: '100px' }}>
                          <input
                            type="number"
                            step="1"
                            min="0"
                            className={`w-full px-1 py-0.5 text-black bg-white focus:ring-1 focus:ring-indigo-200 focus:border-indigo-500 transition-colors text-right font-medium text-xs ${
                              product.isObserItem 
                                ? 'border-gray-300 bg-gray-100 cursor-not-allowed' 
                                : 'border-gray-400'
                            }`}
                            value={product.qty}
                            onChange={(e) => !product.isObserItem && handleQtyChange(index, e.target.value)}
                            placeholder="1"
                            onFocus={(e) => !product.isObserItem && e.target.select()}
                            ref={(el) => (qtyRefs.current[index] = el)}
                            onKeyDown={(e) => {
                              if (!product.isObserItem && e.key === 'Enter') {
                                e.preventDefault();
                                // Focus on the next item selection (next row's product select)
                                const nextIndex = index + 1;
                                if (nextIndex < products.length && productRefs.current[nextIndex]) {
                                  setTimeout(() => {
                                    productRefs.current[nextIndex].focus();
                                  }, 0);
                                } else if (nextIndex === products.length) {
                                  // Last row, add new row and focus on it
                                  addTestRow();
                                  setTimeout(() => {
                                    if (productRefs.current[nextIndex]) {
                                      productRefs.current[nextIndex].focus();
                                    }
                                  }, 150);
                                }
                              }
                            }}
                            disabled={product.isObserItem}
                          />
                        </td>

                        <td className="px-3 py-1.5 text-xs border border-gray-200" style={{ minWidth: '100px' }}>
                          <input
                            type="number"
                            min="0"
                            className={`w-full px-1 py-0.5 text-black bg-white focus:ring-1 focus:ring-indigo-200 focus:border-indigo-500 transition-colors text-right font-medium text-xs ${
                              product.isObserItem 
                                ? 'border-gray-300 bg-gray-100 cursor-not-allowed' 
                                : 'border-gray-400'
                            }`}
                            value={product.rate || ''}
                            onChange={(e) => !product.isObserItem && handleRateChange(index, e.target.value)}
                            onFocus={(e) => !product.isObserItem && e.target.select()}
                            ref={(el) => (rateRefs.current[index] = el)}
                            onKeyDown={(e) => {
                              if (!product.isObserItem && e.key === 'Enter') {
                                e.preventDefault();
                                // Focus on the next item selection (next row's product select)
                                const nextIndex = index + 1;
                                if (nextIndex < products.length && productRefs.current[nextIndex]) {
                                  // Focus on next item selection
                                  setTimeout(() => {
                                    productRefs.current[nextIndex].focus();
                                  }, 0);
                                } else if (nextIndex === products.length) {
                                  // Last row, add new row and focus on it
                                  addTestRow();
                                  setTimeout(() => {
                                    if (productRefs.current[nextIndex]) {
                                      productRefs.current[nextIndex].focus();
                                    }
                                  }, 150);
                                }
                              }
                            }}
                            disabled={product.isObserItem}
                          />
                        </td>

                        <td className="px-3 py-1.5 text-xs text-black font-bold text-right border border-gray-200 whitespace-nowrap" style={{ minWidth: '100px' }}>
                          <input
                            type="number"
                            min="0"
                            className={`w-full px-1 py-0.5 text-black bg-white focus:ring-1 focus:ring-indigo-200 focus:border-indigo-500 transition-colors text-right font-medium text-xs ${
                              product.isObserItem 
                                ? 'border-gray-300 bg-gray-100 cursor-not-allowed' 
                                : 'border-gray-400'
                            }`}
                            value={product.amount || ''}
                            onChange={(e) => !product.isObserItem && handleAmountChange(index, e.target.value)}
                            onFocus={(e) => !product.isObserItem && e.target.select()}
                            ref={(el) => (amountRefs.current[index] = el)}
                            onKeyDown={(e) => {
                              if (!product.isObserItem && e.key === 'Enter') {
                                e.preventDefault();
                                // Focus on the next item selection (next row's product select)
                                const nextIndex = index + 1;
                                if (nextIndex < products.length && productRefs.current[nextIndex]) {
                                  // Focus on next item selection
                                  setTimeout(() => {
                                    productRefs.current[nextIndex].focus();
                                  }, 0);
                                } else if (nextIndex === products.length) {
                                  // Last row, add new row and focus on it
                                  addTestRow();
                                  setTimeout(() => {
                                    if (productRefs.current[nextIndex]) {
                                      productRefs.current[nextIndex].focus();
                                    }
                                  }, 150);
                                }
                              }
                            }}
                            disabled={product.isObserItem}
                          />
                        </td>
                        
                        <td className="px-3 py-1.5 text-xs border border-gray-200">
                          <button
                            type="button"
                            className="p-0.5 bg-red-50 text-red-500 rounded hover:bg-red-100 transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteRow(index);
                            }}
                            title="Remove item"
                          >
                            <MdDelete size={12} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="px-3 py-6 text-center text-sm text-gray-500">
                        No items added. Click the add button to add an item.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="bg-white ml-3 mr-3 mt-3 mb-2 rounded-lg shadow-sm border border-gray-300">
          <div className="p-3">
            {/* First Row - Totals and Options */}
            <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
              {/* Invoice Number */}
              <div className="flex items-center gap-2">
                <span className="text-xs font-medium text-text-black">Invoice:</span>
                <span className="text-sm font-bold text-black">{invoiceNumber}</span>
              </div>

              {/* Grand Total */}
              <div className="flex items-center gap-2 border-l border-r border-gray-300 px-4">
                <span className="text-xs font-semibold text-black">Grand Total:</span>
                <span className="text-base font-bold text-indigo-600">₹{calculateTotal()}</span>
              </div>
              
              {/* Balance Due */}
              <div className="flex items-center gap-2">
                <span className="text-xs font-medium text-red-600">Balance Due:</span>
                <span className="text-sm font-bold text-red-600">
                  ₹{parseFloat((calculateTotal() - (parseFloat(payingAmount) || 0))).toFixed(2)}
                </span>
              </div>

              {/* Print Checkbox */}
              <div className="flex items-center gap-2">
                <label className="inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={printAfterSave} 
                    onChange={(e) => setPrintAfterSave(e.target.checked)}
                    className="text-text-black focus:ring-gray-500 h-4 w-4"
                  />
                  <span className="ml-1.5 text-xs text-black">Print on save</span>
                </label>
              </div>

              {/* Payment Options Accordion */}
              <div className="relative payment-options-container">
                <button
                  type="button"
                  onClick={() => setShowPaymentOptions(!showPaymentOptions)}
                  className="flex items-center gap-2 px-3 py-2 bg-gray-100 text-black text-xs font-medium rounded-md hover:bg-gray-200 transition-colors border border-gray-300"
                >
                  <span>Payment: {paymentMode.toUpperCase()}</span>
                  {showPaymentOptions ? (
                    <FiChevronUp size={14} />
                  ) : (
                    <FiChevronDown size={14} />
                  )}
                </button>

                {/* Payment Options Menu */}
                {showPaymentOptions && (
                  <div className="absolute bottom-full right-0 mb-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg z-50">
                    <div className="p-2 space-y-1">
                      {/* Payment Method Selection */}
                      <div className="px-2 py-1 text-xs font-semibold text-gray-600 border-b border-gray-200">
                        Payment Method
                      </div>
                      <button
                        type="button"
                        onClick={() => {
                          setPaymentMode('Cash');
                          setShowPaymentOptions(false);
                        }}
                        className={`w-full text-left px-3 py-2 text-xs rounded hover:bg-gray-100 transition-colors ${
                          paymentMode === 'Cash' ? 'bg-indigo-50 text-indigo-600 font-medium' : 'text-black'
                        }`}
                      >
                        💵 Cash
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setPaymentMode('Bank');
                          setShowPaymentOptions(false);
                        }}
                        className={`w-full text-left px-3 py-2 text-xs rounded hover:bg-gray-100 transition-colors ${
                          paymentMode === 'Bank' ? 'bg-indigo-50 text-indigo-600 font-medium' : 'text-black'
                        }`}
                      >
                        📱 Bank
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Second Row - Paying Amount and Action Buttons (Right Aligned) */}
            <div className="relative flex justify-end items-center gap-2">
              {/* Bill Date/Time Display (Centered, only in edit mode) */}
              {(isEditMode && originalBillDate) && (
                <div className="absolute left-1/2 transform -translate-x-1/2 text-center z-0">
                  <p className="text-xs text-black font-semibold bg-gray-100 px-3 py-1 rounded-md border border-gray-200/50 opacity-100">
                    Bill Date: {originalBillDate}
                  </p>
                </div>
              )}

              {/* Paying Amount Input */}
              <div className="relative z-10 flex items-center gap-2">
                <label className="text-xs font-medium text-black whitespace-nowrap">Paying Amount:</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="0.00"
                  className="w-32 px-2 py-1.5 text-sm border border-gray-400 bg-white rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500 transition-colors text-black text-right"
                  value={payingAmount || ''}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    if (e.target.value !== '' && !isNaN(value) && value < 0) {
                      toast.error('Paying amount cannot be negative.', { autoClose: 1000 });
                      return;
                    }
                    setPayingAmount(isNaN(value) ? 0 : value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      submitbtnRef.current?.focus();
                    }
                  }}
                  title="Enter the amount being paid"
                />
              </div>

              {/* Action Buttons */}
              <div className="relative z-10 flex items-center gap-2">
                <button 
                  type="button" 
                  className={`px-4 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium text-sm rounded-md hover:from-indigo-700 hover:to-purple-700 shadow-sm transition-all ${
                    isButtonDisabled || isSavingRef.current || (isEditMode && !canEditOpBill) ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                  onClick={handleSave} 
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      if (!isButtonDisabled && !isSavingRef.current && !(isEditMode && !canEditOpBill)) {
                        handleSave();
                      }
                    }
                  }}
                  disabled={isButtonDisabled || isSavingRef.current || (isEditMode && !canEditOpBill)}
                  ref={submitbtnRef}
                  title={isEditMode && !canEditOpBill ? "You don't have permission to edit OP bills." : undefined}
                >
                  Submit
                </button>
                <button 
                  type="button" 
                  className="px-4 py-2 bg-indigo-600 text-white font-medium text-sm rounded-md hover:bg-indigo-700 shadow-sm transition-all"
                  onClick={resetForm}
                >
                  New +
                </button>
              </div>
            </div>
          </div>
        </div>

        {generalsettings?.GbBillTemplate === 'A5' ? (
          <div style={{ position: 'absolute', opacity: 0, top: '-10000px', left: '-10000px' }}>
            <NormalBillPrint
              ref={normalBillPrintRef}  // Add this ref
              invoiceNumber={invoiceNumber}
              selectedPatient={{
                PatientID: selectedPatient?.PatientID || 0,
                PatientName: editName || '',
                Age: editAge || '',
                Gender: editGender || '',
                MobileNo: editNumber || '',
              }}
              selectedDoctor={selectedDoctor}
              payingAmount={id
                ? parseFloat(calculateTotal() - (prevBalanceDue || 0))
                : payingAmount}
              date={billedDate}
              products={products}
              calculateTotal={calculateTotal}
              grand_total={parseFloat(calculateTotal())}
              balance_due={id
                ? parseFloat(prevBalanceDue || 0)
                : parseFloat(calculateTotal() - (parseFloat(payingAmount) || 0))}
              generalSetting={generalsettings}
              sysInfo={sysInfo}
              username={userInfo?.UserName}
              setTotalPages={setTotalPages} 
              setCurrentPageProp={setCurrentPage}
              currentPage={currentPage}
            />
          </div>
        ) : (
          <div style={{ position: 'absolute', opacity: 0, top: '-10000px', left: '-10000px' }}>
            <KotBillPrint
              invoiceNumber={invoiceNumber}
              selectedPatient={{
                PatientID: selectedPatient?.PatientID || 0,
                PatientName: editName || '',
                Age: editAge || '',
                Gender: editGender || '',
                MobileNo: editNumber || '',
              }}
              selectedDoctor={selectedDoctor}
              payingAmount={id
                ? parseFloat(calculateTotal() - (prevBalanceDue || 0))
                : payingAmount}
              date={billedDate}
              products={products}
              calculateTotal={calculateTotal}
              grand_total={ parseFloat(calculateTotal())}
              balance_due={id
                ? parseFloat(prevBalanceDue || 0)
                : parseFloat(calculateTotal() - (parseFloat(payingAmount) || 0))}
              generalSetting={generalsettings}
              username={userInfo?.UserName}
            />
          </div>
        )}
        </div>

        {/* Time-based Billing Popup Modal */}
        {showTimePopup && (
          <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-2xl p-6 w-96 max-w-md mx-4">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Time-based Billing</h3>
                <button
                  onClick={handleTimePopupCancel}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <div className="mb-4">
                <p className="text-sm text-gray-600 mb-2">Item: <span className="font-medium">{timePopupData.itemName}</span></p>
                <p className="text-sm text-gray-600">Base Rate: <span className="font-medium">₹{timePopupData.baseRate}</span></p>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Duration
                  </label>
                  <div className="flex gap-3">
                    <div className="flex-1">
                      <label className="block text-xs text-gray-500 mb-1">Hours</label>
                      <input
                        ref={hoursInputRef}
                        type="number"
                        min="0"
                        max="24"
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-center font-medium"
                        value={timePopupData.hours}
                        onChange={(e) => {
                          const hours = parseInt(e.target.value, 10);
                          if (!isNaN(hours) && hours < 0) {
                            toast.error('Hours cannot be negative.', { autoClose: 1000 });
                            return;
                          }
                          setTimePopupData(prev => ({ ...prev, hours: isNaN(hours) ? 0 : hours }));
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleTimePopupConfirm();
                          }
                        }}
                        placeholder="0"
                      />
                    </div>
                    <div className="flex-1">
                      <label className="block text-xs text-gray-500 mb-1">Minutes</label>
                      <input
                        type="number"
                        min="0"
                        max="59"
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-center font-medium"
                        value={timePopupData.minutes}
                        onChange={(e) => {
                          const minutes = parseInt(e.target.value, 10);
                          if (!isNaN(minutes) && minutes < 0) {
                            toast.error('Minutes cannot be negative.', { autoClose: 1000 });
                            return;
                          }
                          setTimePopupData(prev => ({ ...prev, minutes: isNaN(minutes) ? 0 : minutes }));
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleTimePopupConfirm();
                          }
                        }}
                        placeholder="0"
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 p-3 rounded-lg">
                  <div className="flex justify-between items-center">
                    <span className="text-sm font-medium text-gray-700">Calculated Amount:</span>
                    <span className="text-lg font-bold text-indigo-600">
                      ₹{calculateTimeBasedAmount(timePopupData.baseRate, timePopupData.hours, timePopupData.minutes).toFixed(2)}
                    </span>
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    0-2h: ₹{timePopupData.baseRate} | 2-4h: ₹{timePopupData.baseRate}×2 | 4-6h: ₹{timePopupData.baseRate}×3
                  </div>
                </div>
              </div>

              <div className="flex gap-3 mt-6">
                <button
                  onClick={handleTimePopupCancel}
                  className="flex-1 py-2.5 px-4 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleTimePopupConfirm}
                  className="flex-1 py-2.5 px-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-colors"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default OpBilling;